import { map } from "rxjs/operators";
export function guard(guard, message) {
    return (source) => source.pipe(map((value) => {
        if (guard(value)) {
            return value;
        }
        const error = new Error(message || "Guard rejection.");
        error["value"] = value;
        throw error;
    }));
}
//# sourceMappingURL=guard.js.map